type PresentationTitleSource = {
  title?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
};

export function formatPresentationTitle(
  presentation: PresentationTitleSource,
): string {
  return (
    presentation.title ||
    [presentation.addressLine1, presentation.addressLine2]
      .filter(Boolean)
      .join(", ")
  );
}
